module.exports = __webpack_public_path__ + "img/img-flow-3.87db911c.jpg";